module.exports = __webpack_public_path__ + "media/audio3.afea3496.wav";